// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"559":"486aa009","607":"d55c0f5d"}[chunkId] + ".chunk.css";
};